// Cart utilities supporting patient-scoped storage keys
const STORAGE_PREFIX = 'cart'

function safeParse(v){
  try{ return JSON.parse(v||'[]') }catch(e){ return [] }
}

function storageKeyFor(patientId){
  try{
    if (!patientId) return `${STORAGE_PREFIX}:global`
    return `${STORAGE_PREFIX}:${patientId}`
  }catch(e){ return `${STORAGE_PREFIX}:global` }
}

export function getCart(patientId){
  if (typeof window === 'undefined') return []
  try {
    const k = storageKeyFor(patientId)
    const val = safeParse(localStorage.getItem(k))
    if (val && val.length) return val
    // fallback to legacy key 'cart' if present, migrate it to new key
    const legacy = safeParse(localStorage.getItem('cart'))
    if (legacy && legacy.length){
      try{ localStorage.setItem(k, JSON.stringify(legacy)); localStorage.removeItem('cart') }catch(e){}
      return legacy
    }
    return []
  } catch(e){ return [] }
}

export function saveCart(cart, patientId){
  if (typeof window === 'undefined') return
  try { localStorage.setItem(storageKeyFor(patientId), JSON.stringify(cart||[])) } catch(e){}
  try{ dispatchCartChanged(patientId) }catch(e){}
}

function dispatchCartChanged(patientId){
  try{
    const key = storageKeyFor(patientId)
    window.dispatchEvent(new CustomEvent('cart-changed', { detail: { key } }))
  }catch(e){}
}

export function addToCart(product, patientId){
  const current = getCart(patientId) || []
  const existing = current.find(i => i.id === product.id || i.name === product.name)
  let next
  if (existing) {
    next = current.map(i =>
      (i.id === product.id || i.name === product.name)
        ? { ...i, quantity: (i.quantity || i.qty || 1) + 1 }
        : i
    )
  } else {
    next = [...current, { ...product, quantity: 1 }]
  }
  saveCart(next, patientId)
  return next
}

export function removeFromCart(predicate, patientId){
  const current = getCart(patientId) || []
  const next = current.filter(item => !predicate(item))
  saveCart(next, patientId)
  return next
}

export function clearCart(patientId){
  saveCart([], patientId)
  return []
}

export function buyNow(product){
  if (typeof window === 'undefined') return null
  if (product && product.link) {
    window.open(product.link, '_blank')
    return {action: 'open', url: product.link}
  }
  // fallback behaviour — could integrate real checkout here
  window.alert('Buy now clicked for "' + (product?.name||'product') + '". Implement checkout flow.')
  return {action: 'alert'}
}

export default {
  getCart, saveCart, addToCart, removeFromCart, clearCart, buyNow
}
